import { gql } from "@apollo/client";

export const GET_BOOKING_BY_ID = gql`
  query getBooking($id: ID!) {
    booking(id: $id) {
      id
      bookingTypeId
      bookingId
      time
      status
    }
  }
`;
export const GET_BOOKING_BY_BOOKING_TYPE_ID = gql`
  query getBookingByBookingId($bookingTypeId: Int) {
    getBookingByBookingTypeId(bookingTypeId: $bookingTypeId) {
      time
      status
    }
  }
`;

export const BOOKING_RETURN_FIELDS = gql`
  fragment BookingReturnFields on BookingReturn {
    id
    bookingTypeId
    timezone
    bookingId
    time
    createdAt
    status
    inviteeName
    inviteeEmail
    inviteePhoneNumbers
    recurringOccurrences
    exceptionDates
    bookingTypeName
    bookingTypeColor
    staffName
    staffEmail
    staffId
    duration
  }
`;

// Use the fragment in your queries.
export const GET_BOOKINGS = gql`
  query GetBookings($staffId: Int, $businessId: Int, $selectedYear: Int) {
    getBookings(
      staffId: $staffId
      businessId: $businessId
      selectedYear: $selectedYear
    ) {
      ...BookingReturnFields
    }
  }
  ${BOOKING_RETURN_FIELDS}
`;

export const GET_BOOKINGS_BY_EMAIL = gql`
  query GetBookingsByEmail($email: String, $selectedYear: Int) {
    getBookingsByEmail(email: $email, selectedYear: $selectedYear) {
      ...BookingReturnFields
    }
  }
  ${BOOKING_RETURN_FIELDS}
`;
